﻿"use strict";

import GoogleMapsLoader from "google-maps";
import * as dawaAutocomplete2 from 'dawa-autocomplete2';
const utmgeoconv = require("utmgeoconv");

const areaMap = {

    areas: [],

    setAreas: function () {

        this.areas = [...document.querySelectorAll("[data-area-map='container']")].map(domArea => this.initArea(domArea));
    },

    initArea: function (areaDom) {
        let area = {
            container: areaDom,
            areaListId: areaDom.dataset.areaListId,
            map: areaDom.querySelector("[data-area-map='map']"),
            form: areaDom.querySelector("form[data-area-map='form']"),
            addressInput: areaDom.querySelector("input[data-area-map='address-input']"),
            addresSearchBtn: areaDom.querySelector("button[data-area-map='address-search-btn']"),
            result: areaDom.querySelector("[data-area-map='result']"),
            streetViewContainer: areaDom.querySelector("[data-area-map='streetview-container']"),
            streetViewImg: areaDom.querySelector("img[data-area-map='streetview']"),
            statuses: {
                "-1": [...areaDom.querySelectorAll("[data-area-map='status--1']")],
                "0": [...areaDom.querySelectorAll("[data-area-map='status-0']")],
                "1": [...areaDom.querySelectorAll("[data-area-map='status-1']")],
                "2": [...areaDom.querySelectorAll("[data-area-map='status-2']")],
                "3": [...areaDom.querySelectorAll("[data-area-map='status-3']")]
            },
            address: areaDom.querySelector("[data-area-map='address']"),
            callToAction: areaDom.querySelector("[data-area-map='callToAction']"),
        };

        setTimeout(function () {
            var mapWrapper = document.body.querySelector("[data-area-map='map']");
            if (mapWrapper.querySelector("iframe"))
            {
                mapWrapper.querySelector("iframe").setAttribute("title", "Se om du kan tilsluttes fjernvarme");
                mapWrapper.querySelector("iframe").removeAttribute("frameborder");
            }
        }, 250);

        area.statuses.all = [...area.statuses["-1"], ...area.statuses["0"], ...area.statuses["1"], ...area.statuses["2"], ...area.statuses["3"]];

        return area;
    },

    initMaps: function () {

        GoogleMapsLoader.KEY = "AIzaSyCnkJGT0HnNnWNN1HBvOR8tyjypeXlz1no";
        GoogleMapsLoader.VERSION = "3.56";

        this.areas.map(area => {

            if (area.map) {
                GoogleMapsLoader.load(function (google) {
                    area.googleMap = new google.maps.Map(area.map, {
                        center: { lat: 55.426835, lng: 9.727015 },
                        zoom: 8,
                        disableDefaultUI: true,
                        styles: [
                            {
                                "featureType": "administrative",
                                "elementType": "geometry",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.country",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.country",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.land_parcel",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.neighborhood",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.province",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "administrative.province",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "geometry.fill",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "poi",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "labels",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "road",
                                "elementType": "labels.icon",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "transit",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            },
                            {
                                "featureType": "water",
                                "elementType": "labels.text",
                                "stylers": [
                                    {
                                        "visibility": "off"
                                    }
                                ]
                            }
                        ]
                    });

                    var bounds = new google.maps.LatLngBounds();
                    bounds.extend(new google.maps.LatLng(55.665038, 8.440598));
                    bounds.extend(new google.maps.LatLng(54.917089, 11.102005));
                    area.googleMap.fitBounds(bounds);
                });
            }

        });
    },

    initSearch: function () {
        this.areas.map(area => {
            if (area.addressInput) {
                dawaAutocomplete2.dawaAutocomplete(area.addressInput, {
                    select: selected => {

                        area.selected = selected;
                        this.getCoordinatesBySelected(area);
                    }
                });
            }

            if (area.form) {
                area.form.addEventListener("submit", (event) => {
                    event.preventDefault();
                });
            }
        });

    },

    getCoordinatesBySelected: function (area) {

        if (area.selected) {

            fetch("https://dawa.aws.dk/adgangsadresser?vejnavn=" + area.selected.data.vejnavn + "&husnr=" + area.selected.data.husnr + "&postnr=" + area.selected.data.postnr + "&struktur=mini", {
                method: "GET",
                headers: {
                    "Accept": "application/json"
                }
            })
            .then(response => response.json())
            .then(json => {

                if (json[0]) {

                    area.selectedItem = json[0];
                    this.moveMapToPosition(area);
                    this.calculateUtm32Coords(area);
                    this.searchInGis(area, 0);
                }

            });

        }

    },


    moveMapToPosition: function (area) {

        if (area.selectedItem && area.googleMap) {

            let latLng = { lat: area.selectedItem.y, lng: area.selectedItem.x };

            new google.maps.Marker({
                position: latLng,
                map: area.googleMap,
                title: area.selectedItem.vejnavn + " " + area.selectedItem.husnr + ", " + area.selectedItem.postnr + " " + area.selectedItem.postnrnavn
            });

            area.googleMap.setZoom(16);
            area.googleMap.panTo(latLng);
        }
    },

    calculateUtm32Coords: function (area) {
        if (area && area.selectedItem) {
            area.utm32Coords = utmgeoconv.latLonToUtm(area.selectedItem.y, area.selectedItem.x, 32);
        }
    },

    searchInGis: function (area, layer) {

        if (!area || !area.selectedItem) { return; }
        if (!area.utm32Coords) { this.calculateUtm32Coords(area); }

        var params = {
            x: area.utm32Coords.x,
            y: area.utm32Coords.y,
            vejkode: area.selectedItem.vejkode,
            husnr: area.selectedItem.husnr,
            listId: area.areaListId
        };

        var url = "/umbraco/api/AreaMap/GetStatus?" + Object.keys(params).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(params[key])).join('&');

        fetch(url, {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        })
            .then(response => response.json())
            .then(json => {
                this.setAndShowResult(area, json);
            });

    },



    setAndShowResult: function (area, gisStatus) {
        if (area.result && gisStatus) {
            var address = area.selectedItem.vejnavn + " " + area.selectedItem.husnr;

            if (area.streetViewImg) {
                area.streetViewImg.src = "/umbraco/api/AreaMap/GetStreetView/?location=" + encodeURIComponent(address + ", " + area.selectedItem.postnr + " " + area.selectedItem.postnrnavn);
            }
            if (area.address) {
                area.address.innerText = address;
            }

            var status = gisStatus.status.toString();

            area.statuses.all.map(s => s.classList.add("hidden!"));
            area.statuses[status].map(s => s.classList.remove("hidden!"));
            console.log(gisStatus);

            if (status == "2") {
                area.statuses["2"].filter(s => s.dataset.areaMapCalltoaction !== undefined).map(s => s.setAttribute("href", gisStatus.nextStepLink));
            }
            area.addressInput.blur();
            area.result.classList.remove("hidden");
        }
    },

    hideResult: function (area) {
        if (area.result) {
            area.result.classList.add("hidden");
        }
    },

    init: function () {

        this.setAreas();
        this.initMaps();
        this.initSearch();
  }
};

export default areaMap.init();
